<template>
  <div>
    <div class="h-100">
      <v-layout class="h-100">
        <v-flex xs12 md10 lg7>
          <v-card class="hvh-login-card-actics pa-5 h-100" elevation="3">
            <v-layout column>
              <div class="mb-5">
                <v-form>
                  <v-text-field outline :full-width="true" append-icon="mdi-email" label="Email address" v-model="loginData.email" :rules="emailRules" :counter="75" name="Email" placeholder=" " />
                  <v-text-field
                    outline
                    :full-width="true"
                    :append-icon="loginData.showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="loginData.showPassword ? 'text' : 'password'"
                    label="Password"
                    @click:append="$set(loginData, 'showPassword', !loginData.showPassword)"
                    name="Password"
                    hint="At least 6 characters"
                    min="6"
                    counter
                    placeholder=" "
                    v-model="loginData.password"
                  />
                  <v-btn flat block large class="hvh-btn hvh-btn--primary mt-5" @click="logIn">Log In</v-btn>
                </v-form>
                <loader v-if="loading" />
              </div>
            </v-layout>
          </v-card>
        </v-flex>
        <LoginImageToggler />
      </v-layout>
    </div>
  </div>
</template>
<script>
import axios from '../../axios';
import LoginImageToggler from '../../components/actics/login/LoginImageToggler.vue';
import { createFormData, errorDebug } from '../../libraries/common';
export default {
  noExport: true,
  title: 'Welcome back',
  components: { LoginImageToggler },
  data() {
    return {
      loginData: {},
      loading: false,
    };
  },
  methods: {
    logIn() {
      this.loading = true;
      axios.post('/Account/TestLoginFrontend', createFormData(this.loginData))
        .then(this.getUser)
        .then(() => this.$router.push({ name: 'home' }))
        .catch(errorDebug)
        .then(() => this.loading = false);
    },
    getUser() {
      return axios.get('/Account/GetUser')
        .then(({ data }) => this.$store.state.user = data);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsLogIn'] = this;
  },
}
</script>
